import React from "react";

const FILESTACK_CDN_HOSTS = new Set(["cdn.filestackcontent.com", "cdn.filepicker.io"]);

function getHost(url: string): string {
  return url.split("/")[2] || "";
}

function getHandle(url: string): string {
  return url.split("?")[0].split("/").at(-1) || "";
}

export function isFileStackUrl(url?: string | null): boolean {
  if (!url) {
    return false;
  }
  return FILESTACK_CDN_HOSTS.has(getHost(url));
}

export function buildFileStackUrl(url: string, policyAndSignature: string): string {
  return `https://${getHost(url)}${policyAndSignature}/${getHandle(url)}`;
}

/**
 * Resolves the image url to render: signs Filestack urls, keeps public urls as they
 * are and falls back to the default image while no policy is available.
 */
export function resolveImageUrl(
  url: string | null | undefined,
  policyAndSignature: string,
  fallbackUrl: string
): string {
  if (!url) {
    return fallbackUrl;
  }
  if (!isFileStackUrl(url)) {
    return url;
  }
  if (!policyAndSignature) {
    return fallbackUrl;
  }
  return buildFileStackUrl(url, policyAndSignature);
}

/**
 * Replaces the image by the default one when the file is no longer available in the
 * CDN (expired policy, deleted file), avoiding a broken image on the screen.
 */
export function fallbackOnImageError(fallbackUrl: string) {
  return (event: React.SyntheticEvent<HTMLImageElement>): void => {
    const image = event.currentTarget;
    if (image.src.endsWith(fallbackUrl)) {
      return;
    }
    image.src = fallbackUrl;
  };
}
